module.exports = __webpack_public_path__ + "img/verification-id.c5279f06.svg";